import React, {useEffect} from "react";
import {SubUser} from "../../../services/models/sub_user";
import {Administrator} from "../../../services/models/administrator";
import {useFetchRecom} from "../../../hooks/useQuery/useFetchRecom";
import {LoadingErrorBlock} from "../../../components/shared/LoadingErrorBlock";
import {PageHeader} from "../../../components/shared/PageHeader/PageHeader";
import style from "../../Admin/RecommendationInfo/recomDetail.module.css";
import {CommentBlock} from "./commentBlock";
import fileIcon from '../../../assets/img/fileIcon.svg'
import {formatBytes} from "../../../Utils/uploadFileSettings";
import {API_URL_V2} from "../../../config";
import {RECOMMENDATION_ENDPOINTS} from "../../../services/network/endpoints";
import {FormActionButton} from "../../../components/shared/buttons/FormActionButton";
import {useUpdateStatusRecom} from "../../../hooks/useQuery/useUpdateStatusRecom";
import {BreadcrumbItem} from "../../../components/shared/NewBreadcrumbs/NewBreadcrumbs";
import {useSetReadRecomAndComments} from "../../../hooks/useQuery/useSetReadRecomAndComments";

interface RecommendationInfoPageViewProps {
    user: SubUser | Administrator
    recommendationId: string,
}

const RecommendationInfoPageView = ({user, recommendationId}: RecommendationInfoPageViewProps) => {
    const {recomData, recomError, recomIsLoading} = useFetchRecom(recommendationId)
    const handleOpenFile = () => {
        const fileUrl = `${API_URL_V2}${RECOMMENDATION_ENDPOINTS.GET_FILE}/${recomData?.file}`;
        window.open(fileUrl, '_blank');
    }

    const changeStatusMutation = useUpdateStatusRecom()
    const setReadMutation = useSetReadRecomAndComments()
    useEffect(() => {
        if (recommendationId) {
            setReadMutation.mutate({recomID: recommendationId});
        }
    }, [recommendationId])
    const changeStatusHandler = () => {
        changeStatusMutation.mutateAsync({recomID: recommendationId, statusNum: 1})
    }

    const breadcrumbsItems: BreadcrumbItem[] | undefined = [
        {
            label: "Рекомендации",
            href: "/recommendations",
        },
        {
            label: recomData?.name || "Рекомендация"
        }
    ]
    return (
        <>

            <PageHeader
                isAdmin={false}
                enabledBreadcrumbs={true}
                enabledBackBtn={true}
                title={recomData?.name || "Рекомендация"}
                breadcrumbsItems={breadcrumbsItems}
                buttons={
                    <></>
                }
            />
            <LoadingErrorBlock
                isLoading={recomIsLoading}
                isError={Boolean(recomError)}
                errorMessage="Ошибка загрузки рекомендации. Пожалуйста, попробуйте позже."
            />
            {(recomData && !recomError && !recomIsLoading) && (
                <div className={style.table}>
                    <div className={style.tableRow + " " + style.tableFirst}>
                        {recomData.name}
                    </div>
                    <div className={style.tableRow}>
                        <p className={style.tableCellKey}>
                            Статус
                        </p>
                        <div className={style.tableCellValue}>
                            <div className={style.statusWrapper}>
                                <p> {recomData?.status}</p>
                                {recomData?.status === "Выполняется" && (
                                    <FormActionButton text={"Отправить на оценку"}
                                                      className={style.changeStatusBtn}
                                                      onClick={changeStatusHandler}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className={style.tableRow}>
                        <p className={style.tableCellKey}>
                            Регион
                        </p>
                        <p className={style.tableCellValue}>
                            {recomData.sector}
                        </p>
                    </div>
                    <div className={style.tableRow}>
                        <p className={style.tableCellKey}>
                            Ответственный
                        </p>
                        <p className={style.tableCellValue}>
                            {recomData.in_charge.full_name}
                        </p>
                    </div>
                    <div className={style.tableRow}>
                        <p className={style.tableCellKey}>
                            Срок
                        </p>
                        <p className={style.tableCellValue}>
                            {recomData.deadline}
                        </p>
                    </div>
                    <div className={style.tableRow}>
                        <p className={style.tableCellKey}>
                            Описание
                        </p>
                        <p className={style.tableCellValue}>
                            {recomData.text}
                        </p>
                    </div>
                    <div className={style.tableRow}>
                        <p className={style.tableCellKey}>
                            Целевой показатель
                        </p>
                        <p className={style.tableCellValue}>
                            {recomData.goal}
                        </p>
                    </div>
                    {(recomData?.file && recomData?.file_obj) && (
                        <div className={style.tableRow}
                        >
                            <p className={style.tableCellKey}>
                                Прикрепленный файл
                            </p>
                            <div className={style.tableCellValue}>
                                <div className={style.fileWrapper} onClick={handleOpenFile}>
                                    <img src={fileIcon} alt="Файл"/>
                                    <div className={style.fileData}>
                                        <p className={style.fileName}>{recomData?.file_obj.originalName}</p>
                                        <p className={style.filesize}>{formatBytes(recomData?.file_obj.size)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className={style.tableRow}>
                        <CommentBlock
                            comments={recomData.comments || []}
                            user={user}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default RecommendationInfoPageView;